<script setup>
import {inject} from "vue";
import freezeSkinsModal from "./freezeSkinsModal.vue";

const props = defineProps({
  compName: {
    type: Set,
    default: () => new Set()
  }
})

</script>

<template>
<!--  {{ "全局"+freezeData }}-->
  <!--  冻结皮肤弹框-->
  <freezeSkinsModal v-if="props.compName.has('freezeSkinsModal')" :visible="props.compName.has('freezeSkinsModal')"
                    ref="freezeSkinsModalRef"></freezeSkinsModal>
</template>

<style scoped lang="scss">

</style>